import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'liquidacionesTarjeta',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -30),
        hasta: this.currentdate(),
      }
    }
  },
  computed: {
    reporte: function () {
      return '/reportes/resumen/liquidacion/tarjeta?dsis=' + window.sssdi + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta
    }
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      "orderCellsTop": true,
      "fixedHeader": true
    });
    $('.box').boxWidget();
  },
  methods: {
    consultar() {
      this.loading = true
      this.tbv.clear()
      this.$http
        .post('/reportes/resumen/liquidacion/tarjeta', this.f_c)
        .then(response => {
          this.ventast_tabla = 0
          if (response.data.status === 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              for (let d = 2; d < response.data.data[i].length; d++) {
                response.data.data[i][d] = this.num_to_many(response.data.data[i][d])
              }
              this.tbv.row.add(response.data.data[i])
            }
          }
          this.tbv.draw()
          this.loading = false
        })
    }
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/liquidacionesTarjeta/index.js